export enum Panels {
  EXPERT_REVIEWS = 'ereviews',
  EXPERT_RATINGS = 'eratings',
  CONSUMER_REVIEWS = 'creviews',
  CONSUMER_RATINGS = 'cratings',
  AWARDS = 'awards'
}

export const DEFAULT_TIMEOUT = 10000;
